import { render, staticRenderFns } from "./send-2.vue?vue&type=template&id=71c06646&"
import script from "./send-2.vue?vue&type=script&lang=js&"
export * from "./send-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c06646')) {
      api.createRecord('71c06646', component.options)
    } else {
      api.reload('71c06646', component.options)
    }
    module.hot.accept("./send-2.vue?vue&type=template&id=71c06646&", function () {
      api.rerender('71c06646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/send-2.vue"
export default component.exports